export const getters = {
  formData: (state) => (formularIdentifier) => {
    return state.formData.get(formularIdentifier) || {};
  },
};
